import _slicedToArray from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\slicedToArray.js";
import cn from 'classnames';
import React, { useImperativeHandle, useRef, useState } from 'react';
var DropdownListInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var name = _ref.name,
      autoComplete = _ref.autoComplete,
      value = _ref.value,
      allowSearch = _ref.allowSearch,
      placeholder = _ref.placeholder,
      textAccessor = _ref.textAccessor,
      dataKeyAccessor = _ref.dataKeyAccessor,
      searchTerm = _ref.searchTerm,
      onSearch = _ref.onSearch,
      onAutofill = _ref.onAutofill,
      onAutofillChange = _ref.onAutofillChange,
      renderValue = _ref.renderValue,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      autofilling = _useState2[0],
      setAutofilling = _useState2[1];

  var searchRef = useRef(null);

  var handleAutofillDetect = function handleAutofillDetect(_ref2) {
    var animationName = _ref2.animationName;
    var autofilling;
    if (animationName === 'react-widgets-autofill-start') autofilling = true;else if (animationName === 'react-widgets-autofill-cancel') autofilling = false;else return;
    setAutofilling(autofilling);
    onAutofill(autofilling);
  };

  var handleAutofill = function handleAutofill(e) {
    setAutofilling(false);
    onAutofillChange(e);
  };

  var dataKey = dataKeyAccessor(value);
  var text = value == null ? '' : textAccessor(value);
  var strValue = String(dataKey != null ? dataKey : '');
  if (strValue === String({})) strValue = '';
  var inputValue = !value && placeholder ? /*#__PURE__*/React.createElement("span", {
    className: "rw-placeholder"
  }, placeholder) : renderValue ? renderValue({
    item: value,
    dataKey: dataKey,
    text: text
  }) : text;
  useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        if (searchRef.current) searchRef.current.focus();
      }
    };
  }); // There is some interaction between unmounting the search and value inputs
  // that cancels autofilling in Chrome, it may be due to an input the browser
  // was considering suddenly disappeared. hiding it seems to avoid the issue

  var style = autofilling ? {
    display: 'none'
  } : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "rw-dropdown-list-input"
  }, autoComplete !== 'off' && /*#__PURE__*/React.createElement("input", {
    name: name,
    tabIndex: -1,
    disabled: disabled,
    readOnly: readOnly,
    value: strValue == null ? '' : strValue,
    autoComplete: autoComplete,
    onChange: handleAutofill,
    onAnimationStart: handleAutofillDetect,
    "aria-hidden": !autofilling,
    className: cn('rw-detect-autofill', !autofilling && 'rw-sr')
  }), /*#__PURE__*/React.createElement(React.Fragment, null, allowSearch && /*#__PURE__*/React.createElement("input", {
    ref: searchRef,
    disabled: disabled,
    readOnly: readOnly,
    style: style,
    className: "rw-dropdownlist-search",
    autoComplete: "off",
    value: searchTerm || '',
    size: (searchTerm || '').length + 2,
    onChange: onSearch
  }), !searchTerm && /*#__PURE__*/React.createElement("span", {
    className: "rw-dropdown-list-value",
    style: style
  }, inputValue)));
});
DropdownListInput.displayName = 'DropdownListInput';
export default DropdownListInput;